import { ViewProps } from 'react-native';

enum MB_BLUR_TINT {
  light = 'light',
  dark = 'dark',
  default = 'default',
}

interface MB_BlurProps extends ViewProps {
  /**
   * A tint mode which will be applied to the view.
   *
   * Default: MB_BLUR_TINT.default
   */
  tint?: MB_BLUR_TINT;

  /**
   * A number from `1` to `100` to control the intensity of the blur effect.
   *
   * You can animate this property using `Animated API` from React Native or using `react-native-reanimated`.
   * > Animating this property using `Animated API` from React Native with `setNativeDriver: true` does not work.
   *
   * Default: 20 for Web and iOS
   * Default: 10 for Android (when `androidUseRealBlur` is set to true, otherwise, uses 20)
   */
  intensity?: number;

  /**
   * Determines the overlay color for android blur.
   * Default color based on iOS blurType
   * IMPORTANT: Will disable tint if not undefined
   */
  androidOverlayColor?: string;

  /**
   * Falls back to using expo blur on android if set to true.
   */
  androidUseRealBlur?: boolean;
}

export { MB_BLUR_TINT };
export type { MB_BlurProps };
